import { type INTEGRATIONS, type INTEGRATIONS_V2 } from '../../components/IntegrationButton';
import Grid2 from '@mui/material/Unstable_Grid2';
import { ContentWrapper } from './styles';
import { Header } from '../components/Header';
import { useIntegration } from './hooks';
import { integrationForms } from './forms';
import { type HandleSubmit } from '../../hooks';

type IntegrationProps = {
  integrationName: INTEGRATIONS | INTEGRATIONS_V2 | 'none';
  setIntegrationName: (integrationName: INTEGRATIONS | INTEGRATIONS_V2 | 'none') => void;
  handleSubmit: HandleSubmit;
};

export const Integration = ({ integrationName, setIntegrationName, handleSubmit }: IntegrationProps) => {
  const props = useIntegration({ handleSubmit, integrationName });
  const Form = integrationForms[integrationName];

  return (
    <ContentWrapper>
      <Header integrationName={integrationName} setIntegrationName={setIntegrationName} />
      {Form && (
        <Grid2>
          <Form {...props} />
        </Grid2>
      )}
    </ContentWrapper>
  );
};
